{"15":6.04,"30":6.71,"lastUpdatedOn":"2026-09-03T00:00:00"}